import { Result } from "../../../results/models/result";
import allFacets from "../../constants/all-facets";
import { FacetTypes } from "../../constants/facet-types-enum";
import { FacetStateValues } from "../../models/state/facet-state-values";
import { getFacetFromFieldName } from "../get-facet-from-field-name";
import { RangeValues } from "../../models/types/type-range-values";

export const doesResultMatchFacets = (
	result: Result,
	selectedFacets: FacetStateValues,
) => {
	let itemMatches = true;
	for (let index = 0; index < Object.entries(selectedFacets).length; index++) {
		const selectedFacet = Object.entries(selectedFacets)[index];
		//The field name is the key in the object retrieved rom redux
		var facetFieldName = selectedFacet[0];
		var facet = getFacetFromFieldName(facetFieldName, allFacets);
		switch (facet.type) {
			case FacetTypes.Number:
			case FacetTypes.Range:
				//Get the field value and convert to a number for both ranges and numbers
				//	var fieldName = result[facetFieldName] as string;

				var resultRawFieldValue = result[facetFieldName] as RangeValues;
				var resultFacetNumber = resultRawFieldValue[0];

				switch (facet.type) {
					case FacetTypes.Range:
						var selectedRangeFacet = selectedFacet[1] as RangeValues;

						//If the value from the result field is not a number then it is not a match
						if (Number.isNaN(resultFacetNumber)) {
							itemMatches = false;
						} else {
							if (selectedRangeFacet[0] === 0 && selectedRangeFacet[1] === 0) {
								itemMatches = false;
							} else {
								itemMatches =
									resultFacetNumber >= selectedRangeFacet[0] &&
									resultFacetNumber <= selectedRangeFacet[1];
							}
						}
						break;
					case FacetTypes.Number:
						var resultFacetNumber = result[facetFieldName][1];

						var numberValue = selectedFacet[1] as number;
						itemMatches = resultFacetNumber >= numberValue;
						break;
				}
				break;
			case FacetTypes.Text:
				let selectedTextFacet = selectedFacet[1] as string[];

				if (selectedTextFacet !== null && selectedTextFacet !== undefined) {
					if (selectedTextFacet.length > 0) {
						let resultFieldValue = result[facetFieldName] as string[];
						//If the field does not exist then fail the check
						if (!resultFieldValue) {
							itemMatches = false;
						} else {
							for (let index = 0; index < selectedTextFacet.length; index++) {
								const selectedValue = selectedTextFacet[index];
								if (resultFieldValue.indexOf(selectedValue) === -1) {
									itemMatches = false;
								}
							}
						}
					}
				}

				break;
		}
		if (itemMatches === false) {
			return false;
		}
	}
	return true;
};
